module.exports = __webpack_public_path__ + "img/qfcm-img2.adb5fa6a.png";